<template>
  <div class="document-detail-v2-wrapper">
    <!-- Modales FUERA del contenedor principal para libertad de movimiento -->
    <modal name="modal-supplier" draggable resizable
           :min-width="400"
           :min-height="300"
           :height="thirdPartyModal.height"
           :width="thirdPartyModal.width"
           :shiftX="thirdPartyModal.shiftX"
           :shiftY="thirdPartyModal.shiftY"
           @before-close="setThirdPartyValues"
           styles="border-radius: 30px;">
      <div class="scrollable-card">
        <template v-if="currentDocument && currentDocument.kind == 'in_invoice'">
          <CreateSupplier is-in-modal v-if="Boolean(document_supplierdb_info)" :supplier="document_supplierdb_info.id"
            :key="document_supplierdb_info.id" @createdObject="closeModal" @cancel="closeModalWithCancel"
            :name="currentDocument.metadata['supplier']" :nif="currentDocument.metadata['vat_supplier']"
            :document_id="currentDocument && currentDocument.id">
          </CreateSupplier>
          <CreateSupplier is-in-modal v-else :key="currentDocument.id" :name="currentDocument.metadata['supplier']"
            :nif="currentDocument.metadata['vat_supplier']" @createdObject="closeModal" @cancel="closeModalWithCancel"></CreateSupplier>
        </template>
      </div>
    </modal>

    <modal name="modal-customer" draggable resizable
           :min-width="400"
           :min-height="300"
           :height="thirdPartyModal.height"
           :width="thirdPartyModal.width"
           :shiftX="thirdPartyModal.shiftX"
           :shiftY="thirdPartyModal.shiftY"
           @before-close="setThirdPartyValues"
           styles="border-radius: 30px;">
      <div class="scrollable-card">
        <template v-if="currentDocument && currentDocument.companydb">
          <CreateCustomer is-in-modal v-if="Boolean(document_customerdb_info)" :customer="document_customerdb_info.id"
            @createdObject="closeModal" @cancel="closeModalWithCancel" :key="document_customerdb_info.id"
            :name="currentDocument.metadata['customer']" :nif="currentDocument.metadata['vat_customer']"
            :document_id="currentDocument && currentDocument.id">
          </CreateCustomer>
          <CreateCustomer is-in-modal v-else @createdObject="closeModal" @cancel="closeModalWithCancel" :key="currentDocument.id"
            :name="currentDocument.metadata['customer']" :nif="currentDocument.metadata['vat_customer']">
          </CreateCustomer>
        </template>
      </div>
    </modal>

    <modal
        name="modal-asiento"
        draggable
        resizable
        :min-width="400"
        :min-height="300"
        :height="thirdPartyModal.height"
        :width="thirdPartyModal.width"
        :shiftX="thirdPartyModal.shiftX"
        :shiftY="thirdPartyModal.shiftY"
        styles="border-radius: 30px;"
      >
        <EditAccounting @close-modal="handleCloseModalFromChild">
        </EditAccounting>
    </modal>

    <v-container fluid class="py-0 px-0 document-detail-v2">
      <app-multipane class="split-panes" layout="vertical">
      <!-- Panel Izquierdo: PDF -->
      <div class="pane pdf-pane" :style="{ minWidth: '300px', width: '60%', flexGrow: 0 }">
        <!-- Contenido del PDF -->
        <StaticInvoiceFetcher v-if="showHtmlInvoice && currentDocument.static_invoice" class="scrollable-einvoice"
          v-bind="{invoice_id:currentDocument.static_invoice, companydb_id: currentCompany.id}" :key="documentUrl">
        </StaticInvoiceFetcher>

        <div class="pdf-container">
          <PDFViewer v-bind="{ url: documentUrl , scroll:!feature_pdf_viewer_v3}" @document-errored="onDocumentErrored"
            v-if="((!feature_pdf_viewer_v3 || got_feature('feature_new_invoice_page'))  && documentUrl !== '' && documentFetched) && !showHtmlInvoice && !is_excel">
          </PDFViewer>
          <PDFViewerV2 v-if="(feature_pdf_viewer_v2 && !feature_pdf_viewer_v3 && documentUrl && documentFetched) && !showHtmlInvoice && !is_excel"
            :url="documentUrl" :key="documentUrl">
          </PDFViewerV2>
          <PDFViewerV3 v-if="(!got_feature('feature_new_invoice_page') && feature_pdf_viewer_v3 && !feature_pdf_viewer_v2 && documentUrl && documentFetched) && !showHtmlInvoice && !is_excel"
            :url="documentUrl" :key="documentUrl">
          </PDFViewerV3>

          <div v-else>
            <v-progress-circular v-if="!documentUrl || !documentFetched" indeterminate color="primary">
            </v-progress-circular>
          </div>

          <div style="width: 100%; overflow-x: auto;">
            <div
              style="
                width: 100%;
                min-width: 700px;
                padding: 5px 20px;
                box-sizing: border-box;
              "
            >
              <div
                v-if="is_excel"
                class="container-excel-line-visualizer"
              >
                <div class="download-document">
                  <DocumentDownload
                    :currentDocument="currentDocument"
                    color="white"
                    :key="currentDocument.id"
                  />
                </div>

                <ExcelLineVisualizer :items="currentDocument.excel_row" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Resizer -->
      <app-multipane-resizer></app-multipane-resizer>

      <!-- Panel Derecho: Metadatos -->
      <div class="pane metadata-pane" :style="{ flexGrow: 1, flexBasis: 0, minWidth: '200px' }">
        <RightDrawerClientModeV2
          class="embedded-drawer"
          :splitPaneMode="true"
          @reset-split-pane="resetSplitPane"
        />
      </div>
      </app-multipane>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { vuexPrefix } from "../store/vuex_utils";
import { mapFields } from 'vuex-map-fields';

// PDF components
import PDFUploader from '../components/PDFUploader.vue'
import PDFViewer from '../components/PDFViewer.vue'
import PDFViewerV2 from '../components/pdf/PDFViewerV2.vue'
import PDFViewerV3 from '../components/pdf/PDFViewerV3.vue'

// Third party components
import CreateSupplier from '../views/CreateSupplier.vue';
import CreateCustomer from '../views/CreateCustomer.vue';
import EditAccounting from './EditAccounting.vue';

// Other components
import StaticInvoiceFetcher from "../components/StaticInvoiceFetcher.vue";
import ExcelLineVisualizer from '@/components/ExcelLineVisualizer.vue'
import DocumentDownload from "@/components/DocumentDownload.vue";

// Split pane components
import AppMultipane from '@/components/layout/AppMultipane.vue'
import AppMultipaneResizer from '@/components/layout/AppMultipaneResizer.vue'

// Right drawer (metadata panel)
import RightDrawerClientModeV2 from '@/components/RightDrawerClientModeV2.vue'

export default {
  name: 'DocumentDetailV2',
  props: {
    document: [String, Number]
  },
  components: {
    PDFUploader,
    PDFViewer,
    PDFViewerV2,
    PDFViewerV3,
    CreateSupplier,
    CreateCustomer,
    EditAccounting,
    StaticInvoiceFetcher,
    ExcelLineVisualizer,
    DocumentDownload,
    AppMultipane,
    AppMultipaneResizer,
    RightDrawerClientModeV2
  },
  data() {
    return {
      documentError: undefined,
      enableUploader: process.env.VUE_APP_UPLOAD_ENABLED === 'true',
      proveedor: 'Otro proveedor',
    };
  },
  computed: {
    ...mapGetters([
      "get_suppliers",
      "get_customers",
    ]),
    ...mapState([
      'currentCompany'
    ]),
    ...mapGetters("documents", [
      "documentUrl",
      "documentFetched",
      "currentDocument",
      "currentDocuments",
    ]),
    ...mapGetters({
      got_feature: 'got_feature',
      currentDocument: "documents/currentDocument",
    }),
    ...mapFields('documents', vuexPrefix('document_', ['supplierdb_info', 'customerdb_info', 'kind'], 'document.')),
    ...mapFields('me', vuexPrefix('', [
      'feature_pdf_viewer_v2', 'feature_pdf_viewer_v3','feature_gasto_iva_parcial','feature_iva_deducible_parcialmente',
      'feature_intra_type', 'feature_extra_type', 'feature_extracomunitario_type', 'feature_criterio_de_caja'
    ], 'userData.available_features.')),
    ...mapFields('documents', ['isBienInversionChanged', 'areIvaChecksChanged']),
    ...mapFields('cookies', ['thirdPartyModal']),

    showHtmlInvoice() {
      return this.currentDocument && this.currentDocument.fileName && (this.currentDocument.fileName.includes('.xml') || this.currentDocument.fileName.includes('.xsig'));
    },
    is_excel(){
      return this.currentDocument && this.currentDocument.excel_row && this.currentDocument.excel_row.length != 0
    },
  },
  methods: {
    resetSplitPane() {
      // Restablecer el panel izquierdo al 60% (valor por defecto)
      const pdfPane = this.$el.querySelector('.pdf-pane');
      if (pdfPane) {
        pdfPane.style.width = '60%';
      }
    },
    urlUpdated() {
      this.documentError = undefined;
    },
    start_check_async_job_state(id) {
      this.check_async_job_state(id)
    },
    check_async_job_state(id) {
      if (id == this.$store.state.documents.document.id.toString()) {
        this.fetchDocumentMetadata({ id: this.$store.state.documents.document.id }).then((res) => {
          if (['pending', 'running'].includes(this.$store.state.documents.document.async_job_state)) {
            setTimeout(() => this.check_async_job_state(this.$store.state.documents.document.id), 3000)
          }
          else{
            if (res.data.supplierdb_info) {
              this.currentDocument.supplierdb_info=res.data.supplierdb_info;
            }
            if (res.data.customerdb_info) {
              this.currentDocument.customerdb_info=res.data.customerdb_info;
            }
          }
        })
      }
    },

    onDocumentErrored(e) {
      this.documentError = e.text;
    },
    ...mapActions([
      "setSuppliers",
      "setCustomers",
      "setCurrentCompany",
      "setTags",
      "setSupps",
      "setCusts",
    ]),
    ...mapActions({
      fetchDocument: "documents/fetchDocument",
      fetchDocumentMetadata: "documents/fetchDocumentMetadata",
      selectLabel: "documents/selectLabel",
      cancelRotationMode: "documents/cancelRotationMode",
      updateCurrentIndex: "documents/updateCurrentIndex",
      setCustomers: "setCustomers",
      setSuppliers: "setSuppliers",
      setCurrentDocumentSupplierDB: "documents/setCurrentDocumentSupplierDB",
      setCurrentDocumentCustomerDB: "documents/setCurrentDocumentCustomerDB",
      setCriteriodeCaja: "documents/setCriteriodeCaja",
      setIsComercianteMinorista: "documents/setIsComercianteMinorista",
      updateAutomaticMoveAccounts: "documents/updateAutomaticMoveAccounts",
      forceRefreshUserData: "me/forceRefreshUserData",
      setThirdPartyValues: 'cookies/setThirdPartyValues',
      initialThirdPartyValuesModal: "cookies/initialThirdPartyValuesModal",
      setThirdPartyPosition: 'cookies/setThirdPartyPosition',
      resetCurrentCompany: 'resetCurrentCompany',
      downloadFile :"documents/downloadFile",
    }),
    handleCloseModalFromChild(value) {
      this.$modal.hide("modal-asiento");
      this.$root.$emit("close-modal", value);
    },
    closeModal(object) {
      this.setThirdPartyValues();
      if (this.document_kind == 'in_invoice') {
        this.$modal.hide('modal-supplier');
        this.setSuppliers(this.currentCompany['id']).then(() => {
          let supplierdb_info = {
            'id': object['id'],
            'cif': object['cif'],
            'name': object['name'],
            'expens_accounts': object['expens_accounts'],
            'expens_account_bien_inversion': object['expens_account_bien_inversion'],
            'credit_account': object['credit_account'],
            'company': object['company'],
            'inversion_sujeto_pasivo_iva': object['inversion_sujeto_pasivo_iva'],
            'inversion_sujeto_pasivo_igic': object['inversion_sujeto_pasivo_igic'],
            'inversion_sujeto_pasivo_iva_percent': object['inversion_sujeto_pasivo_iva_percent'],
            'inversion_sujeto_pasivo_igic_percent': object['inversion_sujeto_pasivo_igic_percent'],
            'intracomunitario': object['intracomunitario'],
            'intracomunitario_percent': object['intracomunitario_percent'],
            'extracomunitario': false,
            'no_sujeta': object['no_sujeta'],
            'dry_0_percent': object['dry_0_percent'],
            'bien_inversion': object['bien_inversion'],
            'importaciones_percent': object['importaciones_percent'],
            'iva_igic_no_deducible': object['iva_igic_no_deducible'],
            'gasto_iva_percent': object['gasto_iva_percent'],
            'default_actividad': object['default_actividad'],
            'default_project': object['default_project'],
            'default_channel': object['default_channel'],
            'default_section': object['default_section'],
            'default_delegation': object['default_delegation'],
            'default_department': object['default_department'],
            'building_code': object['building_code'],
            'prorate': object['prorate'],
            'selector_text': object['selector_text'],
            'extended_name': object['extended_name'],
            'retention_type': object['retention_type'],
            'automatic_payment_account': object['automatic_payment_account'],
            'payment_account': object['payment_account'],
            'country': object['country'],
            'default_expens_income_type': object['default_expens_income_type'],
          };
          if(this.feature_criterio_de_caja) {
            supplierdb_info['criterio_de_caja'] = object['criterio_de_caja'];
          }
          if(this.feature_gasto_iva_parcial){
            supplierdb_info['gasto_iva_parcial']=object['gasto_iva_parcial']
          }
          if(this.feature_iva_deducible_parcialmente){
            supplierdb_info['iva_parcial']=object['iva_parcial']
          }
          if(this.feature_intra_type || this.feature_extra_type || this.feature_extracomunitario_type){
            supplierdb_info['intracomunitario_type']=object['intracomunitario_type']
          }

          this.setCurrentDocumentSupplierDB({ 'currentDocumentSupplierdb': object['id'], 'currentDocumentSupplierdbInfo': supplierdb_info, 'isBienInversionChanged': this.isBienInversionChanged, 'areIvaChecksChanged': this.areIvaChecksChanged });
          if (this.feature_criterio_de_caja) {
            this.setCriteriodeCaja(supplierdb_info);
          }
          if (this.got_feature('feature_supplier_comerciante_minorista') && this.currentDocument.companydb_info.tax_type == 'igic') {
            this.setIsComercianteMinorista(supplierdb_info);
          }
          this.updateAutomaticMoveAccounts()
          this.isBienInversionChanged = false;
          this.areIvaChecksChanged = false;
        });
      } else {
        this.$modal.hide('modal-customer');
        this.setCustomers(this.currentCompany['id']).then(() => {
          let customerdb_info = {
            'id': object['id'],
            'cif': object['cif'],
            'name': object['name'],
            'income_accounts': object['income_accounts'],
            'company': object['company'],
            'companydb': object['companydb'],
            'inversion_sujeto_pasivo_iva': object['inversion_sujeto_pasivo_iva'],
            'inversion_sujeto_pasivo_igic': object['inversion_sujeto_pasivo_igic'],
            'inversion_sujeto_pasivo_iva_percent': object['inversion_sujeto_pasivo_iva_percent'],
            'inversion_sujeto_pasivo_igic_percent': object['inversion_sujeto_pasivo_igic_percent'],
            'intracomunitario': object['intracomunitario'],
            'intracomunitario_percent': object['intracomunitario_percent'],
            'extracomunitario': object['extracomunitario'],
            'no_sujeta': object['no_sujeta'],
            'dry_0_percent': object['dry_0_percent'],
            'importaciones_percent': object['importaciones_percent'],
            'iva_igic_no_deducible': object['iva_igic_no_deducible'],
            'default_actividad': object['default_actividad'],
            'default_project': object['default_project'],
            'default_channel': object['default_channel'],
            'default_section': object['default_section'],
            'default_delegation': object['default_delegation'],
            'default_department': object['default_department'],
            'selector_text': object['selector_text'],
            'extended_name': object['extended_name'],
            'automatic_payment_account': object['automatic_charge_account'],
            'payment_account': object['charge_account'],
            'default_expens_income_type': object['default_expens_income_type'],
          };
          if(this.feature_gasto_iva_parcial){
            customerdb_info['gasto_iva_parcial']=object['gasto_iva_parcial']
          }
          if(this.feature_iva_deducible_parcialmente){
            customerdb_info['iva_parcial']=object['iva_parcial']
          }
          if(this.feature_intra_type || this.feature_extra_type || this.feature_extracomunitario_type){
            customerdb_info['intracomunitario_type']=object['intracomunitario_type']
          }

          this.setCurrentDocumentCustomerDB({ 'currentDocumentCustomerdb': object['id'], 'currentDocumentCustomerdbInfo': customerdb_info })
          this.updateAutomaticMoveAccounts()
        });
      }
    },
    closeModalWithCancel() {
      this.setThirdPartyValues();
      if (this.document_kind == 'in_invoice') {
        this.$modal.hide('modal-supplier');
      } else {
        this.$modal.hide('modal-customer');
      }
    }
  },
  async created() {
    console.log('CREATED DocumentDetailV2')
    this.initialThirdPartyValuesModal();
    this.selectLabel({ label: null });
    this.fetchDocument({ id: this.document }).then(async (response) => {
      if (!this.currentCompany || this.currentCompany.id !== response.data.companydb){
        this.resetCurrentCompany({new_company: {id:response.data.companydb}});
      }
      if (this.get_suppliers.length == 0 && this.get_customers.length == 0) {
        if (this.currentDocument.supplierdb_info) {
          this.setSupps([this.currentDocument.supplierdb_info]);
        }
        if (this.currentDocument.customerdb_info) {
          this.setCusts([this.currentDocument.customerdb_info]);
        }
      }
      let company_document = this.currentDocument.companydb;
      if (company_document) {
        this.setSuppliers(company_document);
        this.setCustomers(company_document);
        this.setTags();
      }
      if (['pending', 'running'].includes(this.currentDocument.async_job_state)) {
        setTimeout(() => this.start_check_async_job_state(this.currentDocument.id), 3000)
      }
      if (this.currentDocument.state === 'error_critical'){
        this.forceRefreshUserData()
      }
      if (this.currentDocuments) {
        this.updateCurrentIndex()
      }
    });
  },
  mounted() {
    // Eliminar border-radius del header del PDF cuando está en split pane
    this.$nextTick(() => {
      const header = this.$el.querySelector('.header-pdf-document');
      if (header) {
        header.style.borderTopRightRadius = '0';
      }
    });
  },
  destroyed() {
    this.cancelRotationMode()
    this.$store.dispatch('configuration/setForceRightBar', false);
  },
  watch: {},
}
</script>

<style scoped>
.document-detail-v2-wrapper {
  height: 100%;
  width: 100%;
}

.document-detail-v2 {
  height: 100%;
  padding: 0 !important;
}

.split-panes {
  height: 100%;
}


.pane {
  height: 100%;
  overflow: auto;
}

.pdf-pane {
  background-color: #f5f5f5;
}

.metadata-pane {
  background-color: white;
  border-left: 1px solid #e0e0e0;
  overflow-x: hidden;
  overflow-y: auto;
  height: calc(100vh - 64px);
}

.embedded-drawer {
  max-width: 100%;
}

.scrollable-card {
  height: 100%;
  width: 100%;
  overflow: auto;
}

.scrollable-einvoice {
  position: absolute;
  overflow: auto;
  width: 100%;
  top: 0;
  bottom: 0;
  background-color: white;
  padding-bottom: 150px;
}

.pdf-container {
  height: 100%;
}

.primary-bckground {
  background-color: var(--v-primary-base);
}

.primary-border {
  border-color: var(--v-primary-base) !important;
}

/* Override PDF header border-radius in split pane */
.document-detail-v2 ::v-deep .header-pdf-document {
  border-top-right-radius: 0 !important;
}
.document-detail-v2 >>> .header-pdf-document {
  border-top-right-radius: 0 !important;
}
/deep/ .document-detail-v2 .header-pdf-document {
  border-top-right-radius: 0 !important;
}
</style>

<style lang="scss">
.container-excel-line-visualizer {
  display: flex;
  flex-direction: column;
  padding: 16px;

  .download-document {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 16px;
  }
}

</style>

<!-- Global styles for split pane layout -->
<style>
/* Remove right border-radius from PDF header when in split pane */
.document-detail-v2 .header-pdf-document,
.document-detail-v2 .header-pdf-document.--header-pdf-document-custom {
  border-top-right-radius: 0 !important;
}
</style>
